import React, {FC, useEffect, useState} from "react";
import DataCatalog from "../components/DataCatalog";
import ContentVisual from "../components/ContentVisual";
import ContentHeader from "../components/ContentHeader";
import {MenuInterface} from "../model/MenuInterface";
import axios from "axios";
import { handleError } from "../error/ErrorHandler";
import { useTypedSelector } from "../reducers";
import NcdcCatalogContent from "../components/NcdcCatalogContent";
import ShineEditCatalogContent from "../components/ShineEditCatalogContent";
import { useParams } from "react-router-dom";

type Props = {
    type?: string;
}

const DataCatalogPage: FC<Props> = ({ type }) => {
    const initMenuInfo: MenuInterface = {
        menuId: 0,
        menuNm: '',
        prtMenuId: 0,
        brdYn: '',
        brdId: 0,
        route: '',
        subList: []
    }

    let menuId = 8;

    const { loginUser, status } = useTypedSelector(state => state.auth);
    const { site } = useTypedSelector(state => state.profile);
    const [ menuInfo, setMenuInfo ] = useState(initMenuInfo);
    const [ cstmList, setCstmList ] = useState([]);
    const [ authList, setAuthList ] = useState([]);
    const [ siblings, setSiblings ] = useState([initMenuInfo]);
    const [ hasEditAuth, setHasEditAuth ] = useState(false);
    const [ isEditMode, setIsEditMode ] = useState(false);
    const { catalogId } = useParams();

    const getMenuInfo = async() => {
        try {
            const res = await axios.get(`/api/menu/one/${menuId}`);
            if (res.data) setMenuInfo(res.data);
        } catch(err) {
            handleError(err);
        }
    };

    const getSiblings = async() => {
        try {
            const res = await axios.get(`/api/menu/siblings/${menuId}`);
            if (res.data) setSiblings(res.data);
        } catch(err) {
            handleError(err);
        }
    }

    const getOrgList = async () => {
        try {
            const res = await axios.get('/api/file/all/auth');
            if (res.data) {
                const authList = res.data.map((data: any) => { return { value: data['authCd'], label: data['authNm'] } });
                setAuthList(authList);
            }
        } catch (err) {
            handleError(err);
        }
    }

    const getCstmList = async () => {
        try {
            const res = await axios.get('/api/catalog/cstm/all');
            if (res.data) {
                const cstmList = res.data.map((data: any) => { return { value: data['cstmCd'], label: data['cstmNm'] } })
                setCstmList(cstmList);
            }
        } catch (err) {
            handleError(err);
        } 
    }

    useEffect(() => {
        if (status === 'idle') return;
        setHasEditAuth(loginUser?.usrAuth === 'A');
        setIsEditMode(type === 'write' || type === 'edit');
        getMenuInfo();
        getSiblings();
        getOrgList();
        getCstmList();
    }, [ status, menuId, type ]);

    return (
        <div className={'data-catalog-page-wrapper'}>
            <ContentVisual title={menuInfo.menuNm} />
            <ContentHeader subMenuList={siblings} activeMenuId={Number(menuId)} />
            { isEditMode && 
                <div className={'data-catalog-edit-content'}>
                    {site === 'ncdc' ? <NcdcCatalogContent />
                        : <ShineEditCatalogContent
                            catalogId={catalogId}
                            isAdding={type === 'write'}
                            hasEditAuth={hasEditAuth}
                            authList={authList}
                            cstmList={cstmList} />
                    }
                </div>
            }
            { !isEditMode &&  
                <DataCatalog hasEditAuth={hasEditAuth} site={site} />
            }
        </div>
    );
}

export default DataCatalogPage;
